import { KitPage } from '../../components/pages/products/KitPage'
export default KitPage
